import React from 'react';
import PropTypes from 'prop-types';
import SuggestionsItem from '../suggestions-item';

const SuggestionsList = ({ 
    suggestions = [], 
    active, 
    onItemClick,
}) => {

    const hasPlayers = suggestions.filter(item => item.type === 'p').length;
    const hasTeams = hasPlayers < suggestions.length;
    return (
        <ul className="suggestions-list">
            {hasTeams ? <li className="suggestions-list__section">TEAMS</li> : null}
            {suggestions.map((item, index) => item.type === 't' ? <SuggestionsItem onClickHandler={onItemClick} key={item.id} {...item} active={index === active} /> : null)}
            {hasPlayers ? <li className="suggestions-list__section">PLAYERS</li> : null}
            {suggestions.map((item, index) => item.type === 'p' ? <SuggestionsItem onClickHandler={onItemClick} key={item.id} {...item} active={index === active} /> : null)}
        </ul>
    );

};

SuggestionsList.propTypes = {
    suggestions: PropTypes.array.isRequired,
    active: PropTypes.number,
    onItemClick: PropTypes.func,
};

export default SuggestionsList;
